<template>
    <a href="javascript:void(0)" class="list_sort" @click="clickHeaderEvent"
       :class="{'as_type':isAsc, 'des_type':isDec}">
        {{$t(tagName)}}
    </a>
</template>

<script>
export default{
    name:'ListHeader',
    watch:{
        ClickCnt(){
            if (this.ClickCnt === 1) {
                this.isAsc = true;
                this.isDec = false;
            }
            else if (this.ClickCnt === 2) {
                this.isAsc = false;
                this.isDec = true;
            }
            else{
                this.isAsc = false;
                this.isDec = false;
            }
        }
    },
    props:['ClickCnt','tagName'],
    emits:['clickHeader'],
    data(){
      return{
          isAsc:false,
          isDec:false,
      }
    },
    methods:{
        clickHeaderEvent(event){
            this.$emit('clickHeader',event);
        }
    }
}
</script>